import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import brand from "./brand";

Vue.use(Vuex);

const state = {
  clinicData: {
    clinicName: null,
    clinicImage: null,
    clinicMobile: null,
    clinicAddress: null,
    snapchatLink: null,
    tiktokLink: null,
    facebookLink: null,
    instagramLink: null,
    twitterLink: null,
    videoLink: null,
    whatsappLink: null,
    youTubeLink: null,
  },
};

const mutations = {
  setClinicData(state, item) {
    state.clinicData = item;
  },
  resetClinicData(state) {
    state.clinicData = { ...brand.defaultClinicData };
  },
};

const actions = {
  updateClinicData({ commit }, item) {
    console.log("🚀 ~ updateClinicData ~ item:", item);
    commit("setClinicData", item);
  },
  resetClinicData({ commit }) {
    commit("resetClinicData");
  },
};

const getters = {
  getClinicData: (state) => {
    return state.clinicData;
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [createPersistedState()],
});
